import Button from "components/button";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Modalheader from "components/modal/components/header";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import Yousign from "hooks/yousign";
import ApiDatabase from "server";

const ModalSignature = () => {
  const { toggle } = useModal();
  const { refreshLoadCompany } = UseContext();
  const { dataYousign, signatureLink } = UseContext();

  // disable_domain_validation is only honoured by the YouSign sandbox
  const isSandbox = !!signatureLink && signatureLink.includes("sandbox=true");

  const yousignInit = () => {
    const yousign = new Yousign({
      signatureLink: signatureLink,
      iframeContainerId: "iframe-container",
      isSandbox,
    });

    yousign.onSuccess((data) => {
      console.log("Signer has successfully signed");
    });
  };

  // Closing never waits for the status update: when it failed, the modal used to stay open with
  // nothing on screen. The contract list refreshes once the status is read again.
  const handleClose = (e) => {
    e?.preventDefault();
    toggle();
    ApiDatabase.putStatusContract(
      { contract: dataYousign },
      () => refreshLoadCompany(),
      (err) => console.log(err)
    );
  };

  return (
    <>
      <Modalheader hide={handleClose} hideShow={true}>
        Signature du document
      </Modalheader>
      <ModalBody>
        {signatureLink ? (
        <iframe
          id={"iframe-container"}
          className={"w-full h-[700px]"}
          src={isSandbox ? `${signatureLink}&disable_domain_validation=true` : signatureLink}
          onLoad={yousignInit}
        ></iframe>
        ) : (
          <div className="w-full h-[700px] flex items-center justify-center">
            <div className="flex flex-col items-center gap-4">
              <div className="w-12 h-12 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-gray-600 text-sm">Préparation de la signature...</p>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size={"LG"} color={"SECONDARY"} onClick={handleClose}>
          Fermer
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalSignature;
